export enum IdentityProvider {
  IDS = "IDS",
  PI = "PI"
}

